<template>
  <div class="steps">
    <slot name="header" />
    <form class="form">
      <Suspense>
        <component
          :is="quizComponent(activeStep.component)"
          @complete="handleStepCompleted"
          @close="$emit('close')"
        />
        <template #fallback>
          <Spinner class="spinner" />
        </template>
      </Suspense>
    </form>
    <slot name="footer" />
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { defineAsyncComponent } from "vue";
import Spinner from "@/components/Spinner.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Quiz",
  components: {
    Button,
    Spinner,
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  emits: ["success", "close"],
  data() {
    return {
      isQuizCompleted: false,
      activeStepIndex: 0,
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapState("auth", ["customer"]),
    activeStep() {
      return this.steps[this.activeStepIndex];
    },
    isLastStep() {
      return this.activeStepIndex >= this.steps.length - 1;
    },
  },
  mounted() {
    this.email = this.customer.email;
  },
  methods: {
    quizComponent(component) {
      return defineAsyncComponent({
        loader: () =>
          import(
            /* webpackChunkName: "[request]" */ `@/components/${component}`
          ),
      });
    },
    completeQuiz() {
      this.$emit("close");
    },
    handleStepCompleted() {
      if (this.isLastStep) {
        this.completeQuiz();
      } else {
        this.activeStepIndex++;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.spinner {
  opacity: 0.25;
}
</style>
